"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  var mainVideo = document.querySelector('.bg-video');
  var mainHero = document.querySelector('.main-hero');
  if (mainVideo) {
    var videoWrapper = document.querySelector('.main-hero__video-container');
    mainVideo.addEventListener('ended', function (event) {
      mainHero.classList.add('main-hero__fade-out');
      setTimeout(function () {
        videoWrapper.style.zIndex = 1;
      }, 2000);
    });
  }
});